<template>
	<v-card>
		<v-card-text>
			<v-layout>
				<a @click="$emit('job-click', block.entityId)">
					<span class="font-weight-black">Job: </span>
					<span>
						{{ block.code }}
					</span>
				</a>

				<v-spacer />
				<!-- <v-btn class="right" small icon v-on="on" @click="$emit('jobStagesClick')">
          <v-icon>mdi-buffer</v-icon>
        </v-btn>-->
				<v-btn class="right" small icon :loading="loadingJob"> </v-btn>

				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn
							class="right"
							small
							icon
							v-on="on"
							@click="clickSelect(stage.status, block.id)"
						>
							<v-icon>mdi-chevron-double-right</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item
							v-for="(item, index) in nextStatus"
							:key="index"
							@click="changeStatusManual(item.status, stage.status, block.id)"
						>
							<v-list-item-title>{{ item.status }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-layout>

			<span class="font-weight-black"
				>{{ $tc("entities.item.title", 1) }}:</span
			>

			<span v-if="block.description && block.description.length < 100">
				{{ block.description }}
			</span>

			<span v-else> {{ block.description.substring(0, 100) }}... </span>

			<div class="mt-2" v-if="block.obj.account">
				<span class="font-weight-black"
					>{{ $tc("entities.account.title", 1) }}:</span
				>
				<span>
					{{ block.obj.account.name }}
				</span>
			</div>

			<v-spacer />

			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<!-- <v-btn color="primary" dark v-bind="attrs" v-on="on"> Button </v-btn> -->
					<div class="text-right" v-on="on" v-bind="attrs">
						<v-icon color="blue">mdi-progress-check</v-icon>
						<span color="info" class="font-weight-black">
							{{ parseFloat(qtComp.qtEstimated) }} /
							{{ parseFloat(qtComp.qtReal) }}</span
						>
					</div>
				</template>
				<span>Est / Real</span>
			</v-tooltip>
			<!-- 
      <div class="mt-2 text-right">
        <span class="font-weight-black">Est:</span>
        <span>
          {{ qtComp.qtEstimated }}
        </span>
        <span class="font-weight-black">Real:</span>
        <span>
          {{ qtComp.qtReal }}
        </span>
      </div> -->

			<v-layout>
				<div></div>
				<v-spacer />

				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<div
							v-on="on"
							class="caption"
							:style="
								convertCountDown(block.dateCurrentStatus, block.leadTimeMin)
									.isLate
									? 'color:red'
									: 'color:limegreen'
							"
						>
							{{
								convertCountDown(block.dateCurrentStatus, block.leadTimeMin)
									.result
							}}
						</div>
					</template>
					<span>{{ block.dateCurrentStatus | dateFilter }}</span>
				</v-tooltip>
			</v-layout>
		</v-card-text>
	</v-card>
</template>

<script>
	import moment from "moment";
	import crudActionsMixin from "../../mixins/crudActionsMixin";
	import jobService from "../../services/jobService";

	import "moment-duration-format";

	export default {
		name: "job-card-block-kanban",
		props: ["block", "stages", "stage"],
		components: {},
		mixins: [crudActionsMixin],
		data() {
			return {
				entityService: jobService,
				statusSelected: "",
				job: null,
				jobEditDialog: false,
				loadingJob: false,
			};
		},
		filters: {
			dateFilter(date) {
				return moment(date).format("DD/MM/YY H:mm");
			},
			dateShortFilter(date) {
				return moment(date).format("DD/MM/YYYY");
			},
		},
		computed: {
			nextStatus() {
				if (!this.statusSelected) return [];
				return this.stages.filter((s) => s.status != this.statusSelected);
			},
			qtComp() {
				let qtReal = 0;
				let qtEstimated = 0;
				let obj = this.block.obj;
				let jobStages = obj.jobStages;

				if (!jobStages || jobStages.length == 0) return { qtReal, qtEstimated };

				jobStages.sort((a, b) => {
					if (a.seq > b.seq) return 1;
					else if (a.seq < b.seq) return -1;
					else return 0;
				});
				let lastJobStage = jobStages[0];
				if (!lastJobStage.jobStageItemProds) return { qtReal, qtEstimated };
				let jsp = lastJobStage.jobStageItemProds.filter(
					(i) => i.itemId == obj.itemId
				);

				jsp.forEach((i) => {
					qtReal += i.qtReal;
					qtEstimated += i.qtEstimated;
				});
				return { qtReal, qtEstimated };
			},
		},
		methods: {
			changeStatusManual(status, previousStatus, jobSer) {
				this.clickSelect(status, jobSer);
				this.$emit("update-block", {
					blockId: this.block.entityId,
					nextStatus: status,
				});
			},

			clickSelect(status, jobSer) {
				this.job = JSON.parse(jobSer);
				this.statusSelected = status;
			},

			convertTimeStatusToHours(date) {
				let statusDate = moment(date);
				let now = moment(Date.now());
				var duration = moment.duration(now.diff(statusDate));
				var hours = moment.duration(duration.asHours(), "h").format("H:mm");
				return hours;
			},

			convertCountDown(date, maxMin) {
				//console.log("date: " + date);
				let hours = this.convertTimeStatusToHours(date);
				if (!maxMin)
					return {
						isLate: false,
						result: "",
					};
				let durationInStatusMili = moment.duration(hours).asMilliseconds();

				//console.log("durationInStatusMili: " + durationInStatusMili);
				let durationMaxsMili = maxMin * 60 * 1000;
				//console.log("durationMaxsMili: " + durationMaxsMili);
				let result = durationMaxsMili - durationInStatusMili;
				//console.log("result: " + result);
				let isLate = result < 0;
				let resultAbs = isLate ? Math.abs(result) : result;
				//console.log("resultAbs: " + resultAbs);

				let resultConv = moment.duration(resultAbs).format("hh:mm");
				//console.log("resultConv:" + resultConv);

				let isHours = resultConv.indexOf(":") >= 0;
				if (durationInStatusMili == 0 && !isHours)
					return {
						isLate: false,
						result: `00:${resultConv}`,
					};

				return {
					isLate: isLate,
					result: isLate ? "-" + resultConv : resultConv,
				};
			},

			isLate(hours, maxMin) {
				let hoursConvert = this.convertTimeStatusToHours(hours);

				if (maxMin == null || maxMin == 0) return false;

				this.convertCountDown(hoursConvert, maxMin);

				let durationHours = moment.duration(hoursConvert).asMinutes();
				console.log(durationHours + " / " + maxMin);
				return durationHours > maxMin;
			},
		},
	};
</script>
